<template>
	<b-container fluid="sm">
		<b-row class="container-fluid opcoes-voto">
			<b-col v-for="o in opcoes" :id="o.id" :key="o.id" cols="4" class="container-fluid opcao-voto" style="background-color:darkseagreen;">
				<div>{{ o.identificador }}</div>
				<img :src="consultarImagem(o.id, o.imagem)" class="container-fluid opcao-imagem" style="width:100px;height:auto;"><br>
				<div>{{ o.descricao }}</div>
				<b-button v-if="o.resultado" size="sm" pill variant="info">{{ o.resultado }}</b-button>
				<b-button v-else size="sm" pill variant="success" @click="selecionarVoto(o.id)"><BIconHandThumbsUp /></b-button>
			</b-col>
		</b-row>
		<b-row ref="rowEnvioVoto" class="container-fluid">
			<b-col cols="10" class="container-fluid" style="text-align:center;">
				<label v-show="selecionouCandidato==='true'" for="selecaoCadastro">Possui Cadastro?
					<select id="selecaoCadastro" v-model="possuiCadastro" class="form-control" @change="acessarCadastrese">
						<option value=""></option>
						<option value="true">Sim, já fiz meu Cadastro </option>
						<option value="false">Não fiz meu Cadastro</option>
					</select>
				</label>
				<div v-show="possuiCadastro==='true'">
					<label>Preencha seus dados:</label>
					<div v-if="interno" class="container-fluid"><input ref="matricula" v-model="cadastro.matricula" v-mask="'######'" autofocus class="form-control" placeholder="Matrícula" type="text"></div>
					<div class="container-fluid"><input ref="cpf" v-model="cadastro.cpf" v-mask="'###.###.###-##'" class="form-control" placeholder="CPF" type="text" @blur="habilitarEmail"></div>
					<div class="container-fluid"><input ref="email" v-model="cadastro.email" class="form-control" placeholder="Email" type="text" :disabled="desabilitarEmail"></div>
					<div v-show="desabilitarEmail" class="container-fluid text-danger" :disabled="desabilitarEmail">* Email cadastrado na base de funcionários, se estiver desatualizado enviar email para <a href="mailto:com.eleitoral.cipa@sorocaba.sp.gov.br">com.eleitoral.cipa@sorocaba.sp.gov.br</a> a partir do seu novo email</div>
					<b-button ref="btnEnvioVoto" size="sm" pill variant="success" type="button" @click="votar">ENVIAR VOTO</b-button>
				</div>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
	import $ from 'jquery';
	import Votacao from '../../../models/votacao';
	import Validacao from '@/helpers/cpf';
	import Vue from 'vue';
	import VueMask from 'v-mask';

	Vue.use(VueMask);

	export default {
		data() {
			return {
				idVotoSelecionado: 0,
				interno: false,
				opcoes: [],
				idVotacao: 0,
				desabilitarEmail: false,
				conteudoComprovante: '',
				possuiCadastro: '',
				selecionouCandidato: 'false',
				urlComprovante: '',
				cadastro: {
					email: '',
					nome: '',
					cpf: '',
					dataNascimento: '',
					matricula: ''
				}
			};
		},

		created: async function() {
			this.votacoes = (await Votacao.listarVotacoes()).data;
		},

		methods: {
			acessarCadastrese: function() {
				if (this.possuiCadastro === 'false') {
					setTimeout(function() {
						window.open(window.location.href.replace('votacao', 'cadastro'), '_self');
						window.location.reload();
					}, 1500);
				}
			},

			consultarClasse: function(id) {
				try {
					return require('../../../../assets/img/' + id + '.jpg');
				}
				catch {
					return '';
				}
			},

			consultarImagem: function(id, temImagem) {
				if (temImagem) {
					try {
						return window.Config.BASE_URL + '/votacao/imagem/' + id;
					} catch {
						return require('../../../../assets/img/0.jpg');
					}
				}
				else {
					return require('../../../../assets/img/0.jpg');
				}
			},

			habilitarMatricula: function() {

			},

			habilitarNome: function() {

			},

			habilitarNascimento: function() {

			},

			habilitarEmail: function() {
				var vue = this;
				var numCpf = vue.$refs.cpf.value.replace('.', '').replace('.', '').replace('-', '');
				var numMatricula = '';
				if (vue.$refs.matricula) {
					numMatricula = vue.$refs.matricula.value;
					if (numMatricula != '') {
						numMatricula = '&matricula=' + numMatricula;
					}
				}
				if (numCpf) {
					$.ajax({
						url: `${window.Config.BASE_URL}/eleitor` + '?cpf=' + numCpf + numMatricula,
						method: 'GET',
						contentType: 'application/json',
						success: function(res) {
							if (res)
							{
								vue.cadastro.email = res;
								vue.desabilitarEmail = true;
							}
						},
						error: function() {
						}
					});
				}
			},

			selecionarVoto: function(id) {
				this.idVotoSelecionado = id;
				this.possuiCadastro = 'true';
				for(var i = 0; i < this.opcoes.length; i++) {
					if (document.getElementsByClassName('opcao-voto')[i].id != id) {
						document.getElementsByClassName('opcao-voto')[i].style.display = 'none';
					}
				}
			},

			tipoData: function() {
				this.$refs.nascimento.type = 'date';
			},

			validarVoto: function(voto) {
				var retorno = undefined;

				if (!Validacao.validate(voto.cpf)) {
					return 'Cpf Inválido';
				}
				if (voto.email.split('@').length !== 2 || voto.email.split('@')[1].split('.').length < 2) {
					return 'Email inválido';
				}
				if (this.interno) {
					if (voto.matricula.length === 0) {
						return 'Matrícula inválida';
					}
				}
				return retorno;
			},

			votar: function() {
				var vue = this;
				//var nomeEleitor = vue.$refs.eleitor.value;
				var numCpf = vue.$refs.cpf.value.replace('.', '').replace('.', '').replace('-', '');
				//var nascimento = vue.$refs.nascimento.value;
				var email = vue.$refs.email.value;
				var matricula = undefined;
				if (vue.interno) {
					if (vue.$refs.matricula.value.length > 0) {
						matricula = vue.$refs.matricula.value;
					}
				}
				var voto = { email: email, idOpcao: this.idVotoSelecionado, cpf: numCpf, matricula: matricula };
				//var voto = { email: email, nomeEleitor: nomeEleitor, idOpcao: this.idVotoSelecionado, cpf: numCpf, dataNascimento: nascimento, matricula: matricula };
				var invalido = vue.validarVoto(voto);
				// if (nomeEleitor.split(' ').length < 2) {
				// 	invalido = 'Nome Inválido';
				// }
				// if (!Validacao.validate(numCpf)) {
				// 	invalido = 'Cpf Inválido';
				// }
				// if (email.split('@').length !== 2 || email.split('@')[1].split('.').length < 2) {
				// 	invalido = 'Email inválido';
				// }
				// if (this.interno) {
				// 	if (this.$refs.matricula.value.length > 0) {
				// 		matricula = this.$refs.matricula.value;
				// 	}
				// 	else {
				// 		invalido = 'Matrícula inválida';
				// 	}
				// }
				if (invalido) {
					vue.$refs.btnEnvioVoto.innerText = invalido;
					setTimeout(function() {
						vue.$refs.btnEnvioVoto.innerText = 'Enviar Voto';
					}, 2000);
				} else {
					$.ajax({
						url: `${window.Config.BASE_URL}/votacao/` + vue.idVotacao + '?cpf=' + numCpf,
						data: JSON.stringify(voto),
						method: 'POST',
						contentType: 'application/json',
						success: function(res) {
							if (res == 'Segunda Via de Comprovante'){
								vue.urlComprovante = this.url + '&matricula=' + vue.cadastro.matricula;
								window.open(vue.urlComprovante, '_self');
								vue.conteudoComprovante = this.url + '&matricula=' + vue.cadastro.matricula;
							} else {
								vue.$refs.btnEnvioVoto.innerText = res;
							}
						},
						error: function(message) {
							vue.$refs.btnEnvioVoto.innerText = 'Erro ao votar (' + message.responseJSON.exceptionMessage + ')';
						}
					});
				}
			}
		}
	};
</script>

<style></style>